'use strict';

var ScrollToElement = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'scroll_to',
		offset_y: 0
	},

	initialize: function initialize(_elements, options) {
		this.setOptions(options);
		this._elements = _elements || document.getElements('.' + this.options.cls);

		if (this._elements) {
			this.build();
		}
	},

	build: function build() {
		this.setScrollTo();
	},

	setScrollTo: function setScrollTo() {
		var self = this;

		var myFx = new Fx.Scroll(window, {
			offset: {
				x: 0,
				y: self.options.offset_y,
				duration: 1000
			},
			onStart: function onStart() {
				$(window).fireEvent('jumpStart');
			},
			onComplete: function onComplete() {
				$(window).fireEvent('jumpStop');
			}

		});

		this._elements.each(function (link) {
			link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.hasClass('_top')) {
					myFx.toTop();
					return;
				}

				var name = (this.get('data-href') || this.get('href') || this.href).split('#')[1];
				var elem = $$('a[name=' + name + ']');
				myFx.toElement(elem[0], 'y');
			});
		});
	}
});
'use strict';

/*
--- 
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires: 
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var EqualHeight = new Class({

	initialize: function initialize(element) {
		this._element = element;

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		var _children = this._element.getElements('.equal_height_element');

		if (_children.length == 0) {
			_children = this._element.getChildren();
		}

		if (_children.length > 1) {
			var h = this.height = 0;

			_children.each(function (_el) {

				h = _el.getSize().y - _el.getStyle('padding-top').toInt() - _el.getStyle('padding-bottom').toInt();

				this.height = h > this.height ? h : this.height;
			}.bind(this));

			_children.each(function (_el) {
				_el.setStyle('height', this.height);
			}.bind(this));
		}
	}

});
"use strict";

Page.Mgl = new Class({
	Extends: Page,

	build: function build() {
		this.parent();

		Core.add_equal_height_support();
		Core.stick_last_ads();
	}
});
//# sourceMappingURL=mgl.js.map
